module.exports = __webpack_public_path__ + "img/youtube.54faea37.png";